module.exports = __webpack_public_path__ + "img/login_right_bg.8aa1f115.png";